export default {
    setSyaratJenis(state: any, newData: any) {
        state.syarat = newData.persyaratan;
        state.jenis  = newData.jenis ;
        //localStorage.setItem('user', JSON.stringify(newData));
    }
};
